import React from "react";
import { ToastContainer } from "react-toastify";

interface Props {
  Component: any;
}

const LoginLayout: React.FC<Props> = ({ Component }) => {


  return (
    <>
      <div className="desktop">
          {Component}
      </div>
      <ToastContainer
        autoClose={3000}
        position="top-left"
        className="toast-container"
      />
    </>
  );
};

export default LoginLayout;
